import { all, call, takeEvery } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { request } from '../../xhr';
import { fakeResponse } from './fakeResponse';
import { unsuggestUser } from './actions';
const logger = ddt.createLogger('suggestions');
function* postRequest(url, data) {
    const response = yield call(request, {
        method: 'post',
        url,
        data
    }, fakeResponse(url));
    logger.log('POST:response', response);
    return response;
}
function* handleUnsuggestUser(action) {
    const data = action.payload;
    const response = yield call(postRequest, 'watch/unsuggest', data);
    if (!response || !response.success) {
        logger.error(response.errorDescription);
        return;
    }
}
export default function* userRootSaga() {
    yield all([
        takeEvery(unsuggestUser, handleUnsuggestUser)
    ]);
}
